import React, { useCallback } from "react";
import { SubscriptionPlan } from "./constants";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import {
  selectAccessToken,
  setDodoRedirectUrl,
  setIsAuthenticationOpen,
  setOAuthOpenedFromButton,
} from "lib/redux/uiSlice";
import { createOrder, verifySignature } from "api/subscription/razorpay";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import {
  handlePaymentOutsideIndia,
  ProductPlan,
} from "components/Payment/SubscriptionPlans";
import { retryApiCall } from "lib/utils/retryApiCall";

const SubscriptionCard = ({
  id: selectedPlan,
  level,
  experienceYears,
  price,
  deliverables,
  setLoading: setIsProcessing,
  productPlans,
  countryCode,
}: SubscriptionPlan) => {
  const accessToken = useAppSelector(selectAccessToken);
  const dispatch = useAppDispatch();

  const handlePaymentSuccess = useCallback(async (response: any) => {
    try {
      console.log("Signature to be sent: ", response);
      const verificationResponse = await verifySignature(response);
      console.log("Verification Response: ", verificationResponse);
      if (verificationResponse.verified) {
        window.location.href = "/resume-writing/submit-resume";
      } else {
        setIsProcessing(false);
        alert("Payment verification failed.");
      }
    } catch (error) {
      setIsProcessing(false);
      alert("An error occurred during payment verification.");
    }
  }, []);

  const handlePayment = async () => {
    try {
      setIsProcessing(true);
      // const response = await createOrder({
      //   planId: selectedPlan?.toString(),
      // });
      const response = await retryApiCall(
        () => createOrder({ planId: selectedPlan?.toString() }),
        3
      );
      const orderDetails = response.data;
      const options = {
        key_id: process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID as string,
        amount: orderDetails.amount,
        currency: orderDetails.currency,
        order_id: orderDetails.id,
        name: "Resumemate",
        description: "Payment for subscription",
        image: "/assets/resumemateLogo.png",
        prefill: {
          name: "User's Name",
          email: "user@example.com",
          contact: "1234567890",
        },
        theme: {
          color: "#3399cc",
        },
        method: {
          paylater: false,
        },
        handler: handlePaymentSuccess,
        modal: {
          ondismiss: function () {
            console.log("Checkout form closed.");
            setIsProcessing(false);
            // handlePaymentDismiss();
          },
        },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      setIsProcessing(false);
      console.error("Error...", error);
    }
  };

  const handleSubscribe = () => {
    if (!accessToken) {
      dispatch(setIsAuthenticationOpen(true));
      dispatch(setOAuthOpenedFromButton("resume-writing"));
      return;
    }
    if (countryCode === "IN") {
      handlePayment();
    } else {
      dispatch(setDodoRedirectUrl("/resume-writing/submit-resume"));
      handlePaymentOutsideIndia(productPlans!, selectedPlan);
    }
  };

  return (
    <div className="flex flex-col space-y-5 rounded-3xl border border-gray-400 bg-white p-6 text-xs text-[#071A34] drop-shadow-sm md:text-base">
      <div className="inline-flex items-center gap-1 rounded-3xl border border-black px-2 py-1">
        {level} <span className="font-bold">{experienceYears} years</span>
      </div>
      <div className="text-4xl font-medium md:text-6xl">
        {countryCode === "IN" ? "₹" : "$"}
        {price}
      </div>
      <hr className="border-[#4D4D51]" />
      <ul className="space-y-4">
        {deliverables.map((deliverable, index) => (
          <li className="mt-2 flex items-center gap-3 font-medium" key={index}>
            <CheckCircleIcon className="h-6 w-6 text-gray-600" />
            <span>{deliverable}</span>
          </li>
        ))}
      </ul>
      <button
        className="rounded-3xl border border-gray-400 p-4 font-medium"
        onClick={handleSubscribe}
      >
        Purchase Now
      </button>
    </div>
  );
};

export default SubscriptionCard;
